import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../FaIcon';

// Marca una Línea de Control generada desde un media plan sincronizado (Google Sheets).
// Antes era un ícono de grilla tenue que no se entendía (feedback fede 2026-07-06); ahora es un
// chip con texto, legible sin hover. El tooltip conserva el detalle de dónde salió la línea.
// Compartido entre la tabla de Monitoreo (BusinessUnitRow) y el Panel (BUSummaryRow).
export function MediaPlanBadge() {
    const {t} = useTranslation();
    return (
        <span className="media-plan-badge info-icon-container">
            <FaIcon iconName="rotate"/>
            <span className="media-plan-badge-label">{t('media_plan.bu_badge_label')}</span>
            <div className="warning-tooltip -below">
                <div className="warning-tooltip-body">
                    <p className="warning-tooltip-text">{t('media_plan.bu_badge_tooltip')}</p>
                </div>
            </div>
        </span>
    );
}
